import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types';
import { ComingNomenclatureAdjustmentInfoItem, ComingNomenclatureAdjustmentItem } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getComingNomenclatureAdjustmentDetail: builder.query<ComingNomenclatureAdjustmentItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/comingNomenclatureAdjustment/${data.id}`,
      }),
    }),
    getComingNomenclatureAdjustmentInfo: builder.query<ComingNomenclatureAdjustmentInfoItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/comingNomenclatureAdjustment/${data.id}/info`,
      }),
    }),

    changeComingNomenclatureAdjustment: builder.mutation<void, ComingNomenclatureAdjustmentItem>({
      query: (data) => ({
        url: `/v1/comingNomenclatureAdjustment/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createComingNomenclatureAdjustment: builder.mutation<void, ComingNomenclatureAdjustmentItem>({
      query: (data) => ({
        url: '/v1/comingNomenclatureAdjustment/',
        method: 'POST',
        body: data,
      }),
    }),
    deleteComingNomenclatureAdjustment: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/comingNomenclatureAdjustment/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeComingNomenclatureAdjustmentMutation,
  useCreateComingNomenclatureAdjustmentMutation,
  useDeleteComingNomenclatureAdjustmentMutation,
  useGetComingNomenclatureAdjustmentInfoQuery,
  useGetComingNomenclatureAdjustmentDetailQuery,
  useLazyGetComingNomenclatureAdjustmentInfoQuery,
  useLazyGetComingNomenclatureAdjustmentDetailQuery,
} = request;
